/** Варіанти вибору вузла дерева (напрями) для швидкого поля: обхід углиб, відступ за глибиною, значення — вузол і його піддерево. */
import type { ITreeNode } from '@platform/core/types';

/** Нерозривні пробіли відступу на рівень (звичайні пробіли на початку варіанта браузер згортає). */
const INDENT = '   ';

/**
 * Вузли в порядку дерева (сортування `sort`, далі назва) з підписом-відступом і значенням «ідентифікатор вузла, ідентифікатори нащадків»
 * через кому — фільтр `area:in:…` бере все піддерево (як у прототипі v4). Цикли й обірвані посилання на батька не ламають обхід. Чиста функція.
 */
export function treeOptions(nodes: readonly ITreeNode[]): { value: string; label: string }[] {
  const ids = new Set(nodes.map((n) => n.id));
  const children = new Map<string | null, ITreeNode[]>();
  for (const n of nodes) {
    const parent = n.parentId && ids.has(n.parentId) && n.parentId !== n.id ? n.parentId : null;
    children.set(parent, [...(children.get(parent) ?? []), n]);
  }
  const ordered = (parent: string | null) => [...(children.get(parent) ?? [])].sort((a, b) => a.sort - b.sort || a.name.localeCompare(b.name));
  const subtree = (id: string, guard: Set<string>): string[] =>
    ordered(id).filter((c) => !guard.has(c.id)).flatMap((c) => { guard.add(c.id); return [c.id, ...subtree(c.id, guard)]; });
  const out: { value: string; label: string }[] = [];
  const visited = new Set<string>();
  const walk = (parent: string | null, depth: number) => {
    for (const n of ordered(parent)) {
      if (visited.has(n.id)) continue;
      visited.add(n.id);
      out.push({ value: [n.id, ...subtree(n.id, new Set([n.id]))].join(','), label: `${INDENT.repeat(depth)}${n.name}` });
      walk(n.id, depth + 1);
    }
  };
  walk(null, 0);
  return out;
}
